import styled from "@emotion/styled";
import myThemes from "../../themes/Themes";

export const StyledBanner = styled("div")(({ theme }) => ({
  paddingLeft: "20vh",
  paddingRight: "20vh",
  background: myThemes[theme].palette.primary,
  color: myThemes[theme].palette.quarternary,
}));

export const StyledBannerTitle = styled("div")(({ fireAnimation, theme }) => ({
  zIndex: 1,
  height: "120px",
  background: myThemes[theme].palette.primary,
  fontFamily: "Inter",
  fontWeight: 500,
  fontSize: !fireAnimation ? "35px" : "18px",
  color: myThemes[theme].palette.quarternary,
  marginBottom: "2vh",
  paddingLeft: "20vh",
  paddingRight: "20vh",
  display: "flex",
  alignItems: "center",
  borderBottom: "1px solid #2E133A",
}));
